import {CheckInType} from '../apps/earn-points/data/checkIn';
import {routes as homeRoutes} from '../apps/home/routes';
import {
  registrationRoutes,
  basename as registrationIndexRoute,
} from '../apps/register-account/routes';

export const globalRoutes = {
  ...homeRoutes,
  account: {
    register: {
      index: registrationIndexRoute,
      ...registrationRoutes,
    },
  },
  // TODO fill out incomplete routes
  points: {
    index: '/points',
    checkin: {
      qr_code: '/points/checkin/qr_code/:id',
    } as Record<CheckInType, string>,
  },
};
